import React from 'react';
import { useClientAuthStore } from '@/store/useClientAuthStore';
import FloatingBookButton from './FloatingBookButton';
import DebugInfo from './DebugInfo';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const { user, logout } = useClientAuthStore();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-3">
              <img 
                src="/images/centro-automotriz-hlfrd-icon-3.ico" 
                alt="Centro Automotriz HLFRD"
                className="w-10 h-10 object-contain"
              />
              <div>
                <h1 className="text-xl font-bold" style={{ color: '#2C3E50' }}>
                  Centro Automotriz HLFRD
                </h1>
                <p className="text-xs" style={{ color: '#34495E' }}>Portal de Clientes</p>
              </div>
            </div>
            
            <nav className="hidden md:flex space-x-8">
              <a 
                href="/" 
                className="text-sm font-medium transition-colors duration-200 hover:underline"
                style={{ color: '#34495E' }}
                onMouseEnter={(e) => e.target.style.color = '#FF6B35'}
                onMouseLeave={(e) => e.target.style.color = '#34495E'}
              >
                Inicio
              </a>
              <a 
                href="/services" 
                className="text-sm font-medium transition-colors duration-200 hover:underline"
                style={{ color: '#34495E' }}
                onMouseEnter={(e) => e.target.style.color = '#FF6B35'}
                onMouseLeave={(e) => e.target.style.color = '#34495E'}
              >
                Servicios
              </a>
              <a 
                href="/appointments" 
                className="text-sm font-medium transition-colors duration-200 hover:underline"
                style={{ color: '#34495E' }}
                onMouseEnter={(e) => e.target.style.color = '#FF6B35'}
                onMouseLeave={(e) => e.target.style.color = '#34495E'}
              >
                Citas
              </a>
              <a 
                href="/vehicles" 
                className="text-sm font-medium transition-colors duration-200 hover:underline"
                style={{ color: '#34495E' }}
                onMouseEnter={(e) => e.target.style.color = '#FF6B35'}
                onMouseLeave={(e) => e.target.style.color = '#34495E'}
              >
                Vehículos
              </a>
              <a 
                href="/profile" 
                className="text-sm font-medium transition-colors duration-200 hover:underline"
                style={{ color: '#34495E' }}
                onMouseEnter={(e) => e.target.style.color = '#FF6B35'}
                onMouseLeave={(e) => e.target.style.color = '#34495E'}
              >
                Perfil
              </a>
            </nav>

            <div className="flex items-center space-x-4">
              <a
                href="/quick-book"
                className="px-4 py-2 rounded-lg text-sm font-medium text-white transition-all duration-200 hover:scale-105"
                style={{ backgroundColor: '#3B82F6' }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#2563EB'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#3B82F6'}
              >
                📅 Reservar Cita
              </a>
              <span className="text-sm" style={{ color: '#34495E' }}>
                Hola, {user?.fullName}
              </span>
              <button
                onClick={logout}
                className="px-4 py-2 rounded-lg text-sm font-medium text-white transition-all duration-200 hover:scale-105"
                style={{ backgroundColor: '#FF6B35' }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#FF8C69'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#FF6B35'}
              >
                Salir
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>

      {/* Botón flotante de reserva rápida */}
      <FloatingBookButton />
      
      {/* Debug info (solo en desarrollo) */}
      <DebugInfo />
    </div>
  );
};

export default Layout;